<template>
    <div>
      <div class="foreground">
        <form @submit.prevent="submit">
          <label>
            <span>{{ $t('Email') }}</span>
            <input @keyup="keyup" type="email" name = 'login' v-model="form.login" placeholder="name@email.com">
          </label>
          <label>
            <span>{{ $t('Password') }}</span>
            <input @keyup="keyup" name = 'password' type="password" v-model="form.password">
          </label>
          <p class="error-login" v-show="showError">{{form.error}}</p>
          <button type="submit" class="button-blue">{{ $t('Login1') }}</button>

          <a href="/resetPassword"><span class="forgot">{{ $t('Forgot Password?') }}</span></a>


        </form>
        <p class="need-account">{{ $t('Need a EyesX account?') }} <a href="/register" class="blue"> {{ $t('Create an account') }}</a> </p>
      </div>
      <div class="background"></div>


   </div>
</template>

<script>
import { mapActions } from "vuex";
import i18n from "@/plugins/i18n";
export default {
  name: "Register",
  components: {},
  data() {
    return {
      form: {
        login: "test@test.ru",
        password: "",
        error:''
      },
      showError: false
    };
  },
  methods: {
    ...mapActions(["Register"]),
    keyup(){
      this.showError=false
    },
    async submit() {
      try {
        let res = await this.Register(this.form);
        console.log(res)
        this.$router.push('/mainContent');
        this.showError = false
      } catch (error) {
        console.log(error.response.data.message)
        this.form.error = error.response.data.message
        this.showError = true
      }
    },
  }, async mounted() {

    i18n.locale = this.$store.state.locale

  }
};
</script>
<style>
.error-login{
  text-align: center;
  color: red;
  font-size: 14px;
  margin-top: 0;
}
.login-wrapper{
  max-width: 360px;
}
.login-wrapper button{
  max-width: 360px;
  margin: auto;
  margin-top: 0px;
}
</style>
